import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  imports: [],
  templateUrl: './loading-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loading-screen.component.scss',
})
export class LoadingScreenComponent {
  loadingMessage = input<string>('Loading, please wait...');
}
